import React, { useState, useEffect } from 'react';
import './List_Notification.css';
import config from '../../config';
import SuccessModal from '../modelpopup'; // Import SuccessModal component

const NotificationList = () => {
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [editingId, setEditingId] = useState(null);
    const [editData, setEditData] = useState({ title: '', description: '' });
    const [isSuccessModalVisible, setIsSuccessModalVisible] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');

    useEffect(() => {
        fetchNotifications();
    }, []);

    const fetchNotifications = async () => {
        setLoading(true);
        setError(null);

        try {
            const response = await fetch(`${config.backendUrl}/api/get_notifications`);
            if (!response.ok) throw new Error('Failed to fetch notifications');

            const data = await response.json();
            setNotifications(data);
        } catch (error) {
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    const handleEditClick = (notification) => {
        console.log("Edit button clicked");
        const confirmEdit = window.confirm('Do you want to edit this notification?');
        if (!confirmEdit) return;

        setEditingId(notification.id);
        setEditData({ title: notification.title, description: notification.description });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setEditData((prev) => ({ ...prev, [name]: value }));
    };

    const handleUpdate = async (id) => {
        console.log("Save button clicked");
        const confirmSave = window.confirm('Are you sure you want to save changes?');
        if (!confirmSave) return;

        try {
            const response = await fetch(`${config.backendUrl}/api/update_notification/${id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(editData),
            });

            if (!response.ok) {
                const result = await response.json();
                throw new Error(result.error || 'Failed to update notification');
            }

            setNotifications((prevNotifications) =>
                prevNotifications.map((notification) =>
                    notification.id === id ? { ...notification, ...editData } : notification
                )
            );

            setEditingId(null);
            setEditData({ title: '', description: '' });

            // Show success modal for update
            setSuccessMessage('Notification updated successfully!');
            setIsSuccessModalVisible(true);
            setTimeout(() => {
                setIsSuccessModalVisible(false);
            }, 3000);

        } catch (error) {
            setError(error.message);
        }
    };

    const handleDelete = async (id) => {
        console.log("Delete button clicked");
        const confirmDelete = window.confirm('Are you sure you want to delete this notification?');
        if (!confirmDelete) return;

        try {
            const response = await fetch(`${config.backendUrl}/api/delete_notification/${id}`, { method: 'DELETE' });

            if (!response.ok) {
                const result = await response.json();
                throw new Error(result.error || 'Failed to delete notification');
            }

            setNotifications((prevNotifications) =>
                prevNotifications.filter((notification) => notification.id !== id)
            );

            // Show success modal for delete
            setSuccessMessage('Notification deleted successfully!');
            setIsSuccessModalVisible(true);
            setTimeout(() => {
                setIsSuccessModalVisible(false);
            }, 3000);

        } catch (error) {
            setError(error.message);
        }
    };

    return (
        <div className="notification-container">
            <h2 className="header">Notification List</h2>

            {loading ? (
                <p className="loading-message">Loading notifications...</p>
            ) : error ? (
                <p className="error-message">{error}</p>
            ) : (
                <div className="table-wrapper">
                    <table className="notification-table">
                        <thead>
                            <tr>
                                <th>Title</th>
                                <th>Description</th>
                                <th>Date</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {notifications.length > 0 ? (
                                notifications.map((notification) => (
                                    <tr key={notification.id}>
                                        <td>
                                            {editingId === notification.id ? (
                                                <input
                                                    type="text"
                                                    name="title"
                                                    value={editData.title}
                                                    onChange={handleInputChange}
                                                />
                                            ) : (
                                                notification.title
                                            )}
                                        </td>
                                        <td>
                                            {editingId === notification.id ? (
                                                <input
                                                    type="text"
                                                    name="description"
                                                    value={editData.description}
                                                    onChange={handleInputChange}
                                                />
                                            ) : (
                                                notification.description
                                            )}
                                        </td>
                                        <td>{notification.date ? new Date(notification.date).toLocaleDateString() : 'No date available'}</td>
                                        <td>
                                            <div className="action-buttons">
                                                {editingId === notification.id ? (
                                                    <button className="save-btn" onClick={() => handleUpdate(notification.id)}>Save</button>
                                                ) : (
                                                    <button className="edit-btn" onClick={() => handleEditClick(notification)}>Edit</button>
                                                )}
                                                <button className="delete-btn" onClick={() => handleDelete(notification.id)}>Delete</button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="4" className="no-data">No notifications available</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            )}

            {/* Success Modal */}
            {isSuccessModalVisible && (
                <SuccessModal message={successMessage} onClose={() => setIsSuccessModalVisible(false)} />
            )}
        </div>
    );
};

export default NotificationList;
